module.exports = __webpack_public_path__ + "static/img/label_remark.557a46ea.png";